import { Content } from "@/components/Dialog/Content"
import { Footer } from "@/components/Dialog/Footer"
import { Header } from "@/components/Dialog/Header"
import { CloseIconButton } from "@/components/Dialog/CloseIconButton"
import { Title } from "@/components/Dialog/Title"
import { Container } from "@/components/Dialog/Container"
import { ConfirmButton } from "@/components/Dialog//ConfirmButton"
import { CancelButton } from "@/components/Dialog//CancelButton"

export const Dialog = {
	Container,
	Title,
	Content,
	CloseIconButton,
	Footer,
	Header,
	ConfirmButton,
	CancelButton
}